const SW_PATH = `${process.env.PUBLIC_URL || ""}/sw.js`;
const UPDATE_INTERVAL_MS = 60 * 1000;

export function registerServiceWorker() {
   if (process.env.NODE_ENV !== "production") return;
   if (!("serviceWorker" in navigator)) return;

   let refreshing = false;

   navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
   });

   window.addEventListener("load", async () => {
      try {
         const registration = await navigator.serviceWorker.register(SW_PATH);

         const activateWaitingWorker = () => {
            if (registration.waiting) {
               registration.waiting.postMessage({ type: "SKIP_WAITING" });
            }
         };

         registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener("statechange", () => {
               if (
                  newWorker.state === "installed" &&
                  navigator.serviceWorker.controller
               ) {
                  activateWaitingWorker();
               }
            });
         });

         const checkForUpdates = () => {
            registration.update().catch(() => {});
         };

         activateWaitingWorker();
         checkForUpdates();
         setInterval(checkForUpdates, UPDATE_INTERVAL_MS);

         window.addEventListener("focus", checkForUpdates);
         document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
               checkForUpdates();
            }
         });
      } catch (error) {
         console.error("Service worker registration failed:", error);
      }
   });
}
